/**
 * Декодирование файла банковской выписки 1С перед отправкой на сервер.
 *
 * Банки Казахстана отдают «1CClientBankExchange» чаще всего в Windows-1251,
 * иногда в UTF-8 и изредка в DOS (cp866) — о кодировке файл сообщает сам,
 * строкой «Кодировка=» в заголовке. Прочитать эту строку можно, только уже
 * угадав кодировку, поэтому файл пробуется в однобайтовых кодировках, и
 * выбирается та, в которой заголовок называет её сам. Иначе — UTF-8.
 */

const SINGLE_BYTE: readonly { readonly label: string; readonly declares: RegExp }[] = [
  { label: 'windows-1251', declares: /^\s*Кодировка\s*=\s*Windows/im },
  { label: 'ibm866', declares: /^\s*Кодировка\s*=\s*DOS/im },
];

/** Первые килобайты заголовка: «Кодировка=» стоит в первых строках файла. */
const HEADER_BYTES = 4096;

export function decodeStatementFile(bytes: Uint8Array): string {
  const head = bytes.subarray(0, HEADER_BYTES);
  for (const { label, declares } of SINGLE_BYTE) {
    if (declares.test(new TextDecoder(label).decode(head))) {
      return new TextDecoder(label).decode(bytes);
    }
  }
  return new TextDecoder('utf-8').decode(bytes);
}

export function readStatementFile(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (result instanceof ArrayBuffer) resolve(decodeStatementFile(new Uint8Array(result)));
      else reject(new Error('файл не прочитан'));
    };
    reader.onerror = () => reject(reader.error ?? new Error('файл не прочитан'));
    reader.readAsArrayBuffer(file);
  });
}
